export const colors = {
  Gelb: 'rgba(213, 227, 131, 0.4)',
  Grün: 'rgba(114, 200, 182, 0.4)',
  Blau: 'rgba(134, 212, 232, 0.4)',
  Orange: 'rgba(240, 168, 126, 0.4)',
}
